/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_PurchasesInputs */

const en_my_purchases = /** @type {(inputs: My_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Purchases`)
};

const es_my_purchases = /** @type {(inputs: My_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis compras`)
};

const fr_my_purchases = /** @type {(inputs: My_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes achats`)
};

const de_my_purchases = /** @type {(inputs: My_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Käufe`)
};

const ja_my_purchases = /** @type {(inputs: My_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入履歴`)
};

const zh_my_purchases = /** @type {(inputs: My_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的已购`)
};

const ar_my_purchases = /** @type {(inputs: My_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشترياتي`)
};

const id_my_purchases = /** @type {(inputs: My_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembelian Saya`)
};

const it_my_purchases = /** @type {(inputs: My_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I Miei Acquisti`)
};

const ru_my_purchases = /** @type {(inputs: My_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мои покупки`)
};

const pt_my_purchases = /** @type {(inputs: My_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minhas Compras`)
};

const ko_my_purchases = /** @type {(inputs: My_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나의 구매 내역`)
};

/**
* | output |
* | --- |
* | "My Purchases" |
*
* @param {My_PurchasesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const my_purchases = /** @type {((inputs?: My_PurchasesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_PurchasesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_my_purchases(inputs)
	if (locale === "es") return es_my_purchases(inputs)
	if (locale === "fr") return fr_my_purchases(inputs)
	if (locale === "de") return de_my_purchases(inputs)
	if (locale === "ja") return ja_my_purchases(inputs)
	if (locale === "zh") return zh_my_purchases(inputs)
	if (locale === "ar") return ar_my_purchases(inputs)
	if (locale === "id") return id_my_purchases(inputs)
	if (locale === "it") return it_my_purchases(inputs)
	if (locale === "ru") return ru_my_purchases(inputs)
	if (locale === "pt") return pt_my_purchases(inputs)
	return ko_my_purchases(inputs)
});